import { render, staticRenderFns } from "./MonitorScreen.vue?vue&type=template&id=8edc5948&scoped=true"
import script from "./MonitorScreen.vue?vue&type=script&lang=js"
export * from "./MonitorScreen.vue?vue&type=script&lang=js"
import style0 from "./MonitorScreen.vue?vue&type=style&index=0&id=8edc5948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc5948",
  null
  
)

export default component.exports